import React, {useState, useEffect} from 'react';
import moment from 'moment';

import {DialogWindow, CustomAvatar} from  './general';
import { getTicketId } from '../util';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { Chip, Stack, Badge, Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import Stepper from './customStepper.js'
import { flexbox } from '@mui/system';
import { sendReceipt, printReceipt } from '../services/booking'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DownloadIcon from '@mui/icons-material/Download';

const classes = {
    root: {
      width: '100%',
      position:'relative',
      minHeight: 'calc(100vh - 200px)'
    },
    firstRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: 20

    },
    tenant :{
        display: 'flex'
    },
    rowInd: {
        margin: '0px 10px'
    },
    chip: {
        fontWeight: 'bold'
    },
    rowItem: {
        fontSize: '14px',
        marginBottom: '5px'
    },
    dates: {
        display:'flex',
        alignItems: 'center',
        fontSize:"14px"
    },
    smallfont: {
        fontSize: '12px',
    },
    cashCont: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-around',
        marginBottom: '15px',
        fontSize: 14,
        width: '60%'
    },
    prodCont: {
      display: 'flex',
      flexDirection:'column',
      width: '50%'
    },
    indProductCont: {
      display: 'flex',
      alignItems: 'center'
    },
    indProductItem: {
      marginLeft: '10px'
    },
    bottomRow: {
      display: 'flex',
      marginTop: '20px',
    },
    noteCont:{
      display: flexbox,
      width:'50%'
    },
    indNoteCont: {
      marginBottom: '5px'
    },
    noteTitle:{
      fontWeight: 'bold',
      fontSize: '14px',
      textDecoration: 'underline'
    },
    note: {
      fontSize: '14px'
    }
}
  
const SendReceiptButton = ({status, id, setShowSnack, setSnackMessage, setSnackType, contactNumber}) => { 
  const allowedStatuses = ['checkedout', 'checkedin', 'closed']    
  const receiptLocation = '/public/receipts'

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSend =  async() => {
    try {
      await sendReceipt(id)
      setSnackMessage("Receipt Sent")
      setSnackType("success")
      setShowSnack(true)
    } catch (e) {
      console.log(e)
      setSnackMessage("Could not send receipt")
      setSnackType("error")
      setShowSnack(true)
    }
  }
  
  const handleDownload = async() => {
    const pdfUrl = `${receiptLocation}/${id}.pdf`
    try {
      let res = await fetch(pdfUrl, { method: "GET" });

      if (!res.ok) {
        console.log(res)
      // backend returns 404 or 500 etc
        await printReceipt(id)
        res = await fetch(pdfUrl, { method: "GET" });
      }

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = `${id}_reciept.pdf`;
      a.click();
      window.URL.revokeObjectURL(url);

    } catch (err) {
      console.error("Download failed:", err);
        setSnackMessage("Could not send receipt")
        setSnackType("error")
        setShowSnack(true)
    }
  }

  const handleShare = async() => {
    const pdfUrl = `${receiptLocation}/${id}.pdf`
    try {
    let res = await fetch(pdfUrl, { method: "GET" });

    if (!res.ok) {
      await printReceipt(id)
      res = await fetch(pdfUrl, { method: "GET" });
    }

    const blob = await res.blob();
    const url = window.URL.createObjectURL(blob);

    const phone = `91${contactNumber}`; // ← change
    const message = `Download your receiept https://admin.bookmycam.com${pdfUrl} `;
    const waUrl = `https://wa.me/${phone}?text=${message}`;

    window.open(waUrl, "_blank");
    // no revoke here immediately, because whatsapp needs to read the link
    // optionally revoke after 5 seconds
    setTimeout(() => window.URL.revokeObjectURL(url), 5000);

    } catch (err) {
        console.error("Failed:", err);
        setSnackMessage("Could not send receipt")
        setSnackType("error")
        setShowSnack(true)
    }
  }

  if (allowedStatuses.indexOf(status) > -1) {
    return (
      <>
        <Button sx={{width: '150px' }}onClick={handleClick} variant='contained'  endIcon={<KeyboardArrowDownIcon />}>Receipt</Button>
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          PaperProps={{
          sx: {
            width: anchorEl ? anchorEl.offsetWidth : undefined
          }
        }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
        >
          <MenuItem onClick={() => { handleSend(); handleClose(); }}>
            <EmailIcon sx={{mr: 2}}/>
            Mail
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); handleShare()}}>
            <WhatsAppIcon sx={{mr: 2}}/>
            Whatsapp
          </MenuItem>
          <MenuItem onClick={() => { handleClose(); handleDownload();}}>
            <DownloadIcon sx={{mr: 2}}/>
            Download
          </MenuItem>
        </Menu>
      </>
    )
  }
}

const IndProduct = ({product, index}) => {
    return (
      
        <div style={classes.indProductCont}>
          <div style={classes.indProductItem}># {index+1}</div>
          <div style={classes.indProductItem}><img height={50} src={product?.image?.thumb??''}/></div>
          
          <div style={classes.indProductItem}>{product.name}</div>
          <Badge badgeContent={product.count} sx={{marginLeft:'15px'}} color="primary">
          </Badge>
        </div>
    )
  }
const IndNote = ({title, note}) => {
  const titleMap = {
    bookingNotes: 'Booking Notes :-',
    checkoutNotes: 'Checkout Notes :-',
    checkinNotes: 'Checkin Notes :-'
  }
  if (note) {
    return (
      <div style={classes.indNoteCont}>
        <div style={classes.noteTitle}>{titleMap[title]}</div>
        <div style={classes.note}>{note}</div>
      </div>
    )
  }
  return null;

}
const BookDetails = (props) => {
    const getChipStyle = (status) => {
        if (status==='booked') {
          return {border: '2px solid #54A0FF', color: '#54A0FF'}
        }
        if (status === 'checkedout') {
          return {border: '2px solid #F39C12', color: '#F39C12'}
        }
        if (status === 'checkedin') {
          return {border: '2px solid #E74C3C', color: '#E74C3C'}
        }
        if (status === 'closed') {
          return {border: '2px solid #30CB83', color: '#30CB83'}
        }
        if (status === 'cancelled') {
          return {border: '2px solid #34495E', color: '#34495E'}
        }
      }

      const {_id, tenant ={}, status, to, from, products =[], advance, notes, amount, discount, timeline, billableDates, setShowSnack, setSnackMessage, setSnackType} = props
      const steppers = (() => {
              const regularsteppers =['booked', 'checkedout', 'checkedin', 'closed'];
              const creditedSteppers =['booked', 'checkedout', 'checkedin', 'credited', 'closed'];
              const cancelledSteppers = ['booked', 'cancelled'];
              if (status === 'cancelled') {
                return cancelledSteppers
              } else if (timeline.find(_timeline => _timeline.status === "credited")){
                return creditedSteppers
              }
              return regularsteppers
      })()
      if (props.isMobile) {
        return (
          <div style={{width: '100%'}}>
              <div style={classes.firstRow}>
                  <div style={classes.tenant}>
                      <CustomAvatar style={{...classes.cardItem, ...classes.rowInd}} src={tenant?.image?.thumb??''} name={tenant?.name}/>
                      <div style={classes.tenantText}>
                          <div style={classes.rowItem}>{tenant?.name}</div>
                          <div style={classes.rowItem}>{tenant?.contactNumber}</div>
                      </div>
                  </div>
                  <Chip sx={{...classes.topInd, ...classes.chip}} style={getChipStyle(status)} label={status} />
              </div>
              <Box sx={{mb: 1, display: 'flex', flexDirection: 'row', alignItems:'center', justifyContent: 'flex-end'}}>
                <SendReceiptButton status={status} id={_id} setShowSnack={setShowSnack} setSnackMessage={setSnackMessage} setSnackType={setSnackType} contactNumber={tenant?.contactNumber}/>
              </Box>
              <div style={{...classes.dates, marginBottom:'10px'}}>
              <Box sx={{display: 'table', width: '100%'}}>
                    <Box sx={{display: 'table-row'}}>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <CalendarMonthIcon/>
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(from).format('Do MMM YY (ddd)')}</div> 
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                      <div style={classes.rowInd}>{moment(to).format('Do MMM YY (ddd)')}</div>  
                      </Box>
                    </Box>
                    
                    <Box sx={{display: 'table-row'}}>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <AccessTimeIcon/>  
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(from).format('HH:mm A')}</div> 
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(to).format('HH:mm A')}</div>
                      </Box>
                    </Box>
                    {/*<Stack spacing={1}>
                      <div style={{...classes.rowInd, ...classes.smallfont}}>{moment(to).startOf('day').diff(moment(from).startOf('day'), 'days')+1} days</div>
                    </Stack>*/}
                  </Box>
                </div>
              <div style={{...classes.cashCont, width: '100%'}}>
                  <Stack direction="column" alignItems="center" justifyContent="center">
                    <Typography  sx={{fontSize: 12}}>Billable Days</Typography>
                    <Typography  sx={{fontSize: 12}}>{billableDates?.length}</Typography>
                  </Stack>
                   <Stack direction="column" alignItems="center" justifyContent="center">
                    <Typography  sx={{fontSize: 12}}>Discount</Typography>
                    <Typography  sx={{fontSize: 12}}>₹ {discount || 0}</Typography>
                  </Stack>
                   <Stack direction="column" alignItems="center" justifyContent="center">
                    <Typography  sx={{fontSize: 12}}>Advance</Typography>
                    <Typography  sx={{fontSize: 12}}>₹ {advance || 0}</Typography>
                  </Stack>
                   <Stack direction="column" alignItems="center" justifyContent="center">
                    <Typography  sx={{fontSize: 12}}>Balance</Typography>
                    <Typography  sx={{fontSize: 12}}>₹ {amount - advance}</Typography>
                  </Stack>
              </div>
              <Stepper timeline={timeline} steppers={steppers} isMobile={props.isMobile}/>
              <div style={{...classes.bottomRow, marginBottom: '10px'}}>
                <div style={{...classes.prodCont, width: '100%'}}>{products.map((product, index)=><IndProduct index={index} key={`product-${index}`} product={product}/>)}</div>
              </div>
              <div>
                <div style={classes.noteCont}>{Object.keys(notes).map((note, index)=><IndNote index={index} key={`note-${index}`} title={note} note={notes[note]}/>)}</div>
              </div>
          </div>
        )
      }
    return (
        <div style={classes.detailCont}>
            <div style={classes.firstRow}>
                <div style={classes.tenant}>
                    <CustomAvatar style={{...classes.cardItem, ...classes.rowInd}} src={tenant?.image?.thumb??''} name={tenant?.name}/>
                    <div style={classes.tenantText}>
                        <div style={classes.rowItem}>{tenant?.name}</div>
                        <div style={classes.rowItem}>{tenant?.contactNumber}</div>
                    </div>
                </div>
                <div>{getTicketId(_id)}</div>
                <Chip sx={{...classes.topInd, ...classes.chip}} style={getChipStyle(status)} label={status} />
                <SendReceiptButton status={status} id={_id} setShowSnack={setShowSnack} setSnackMessage={setSnackMessage} setSnackType={setSnackType} contactNumber={tenant?.contactNumber}/>
                <div style={classes.dates}>
                  <Box sx={{display: 'table'}}>
                    <Box sx={{display: 'table-row'}}>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <CalendarMonthIcon/>
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(from).format('Do MMM YY (ddd)')}</div> 
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                      <div style={classes.rowInd}>{moment(to).format('Do MMM YY (ddd)')}</div>  
                      </Box>
                    </Box>
                    
                    <Box sx={{display: 'table-row'}}>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <AccessTimeIcon/>  
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(from).format('HH:mm A')}</div> 
                      </Box>
                      <Box sx={{display: 'table-cell', verticalAlign: "middle", textAlign: 'start'}}>
                        <div style={classes.rowInd}>{moment(to).format('HH:mm A')}</div>
                      </Box>
                    </Box>
                    {/*<Stack spacing={1}>
                      <div style={{...classes.rowInd, ...classes.smallfont}}>{moment(to).startOf('day').diff(moment(from).startOf('day'), 'days')+1} days</div>
                    </Stack>*/}
                  </Box>
                </div>
            </div>
            <div style={classes.cashCont}>
                <div>Billable Days : {billableDates?.length}</div>
                <div>Advance : ₹{advance || 0}</div>
                <div>Amount : ₹{amount}</div>
                <div>Balance : ₹{amount - advance - discount}</div>
                <div>Discount : ₹{discount || 0}</div>
            </div>
            <Stepper timeline={timeline} steppers={steppers}/>
            <div style={classes.bottomRow}>
              <div style={classes.prodCont}>{products.map((product, index)=><IndProduct index={index} key={`product-${index}`} product={product}/>)}</div>
              {notes && <div style={classes.noteCont}>{Object.keys(notes).map((note, index)=><IndNote index={index} key={`note-${index}`} title={note} note={notes[note]}/>)}</div>}
            </div>
        </div>
    )
}

const Body = ({bookDetails, isMobile, setShowSnack, setSnackMessage, setSnackType }) => {
    return (
      <div style={classes.delDialogCont}>
        <div style={classes.delDialogLeft}>
          <BookDetails isMobile={isMobile} {...bookDetails} setShowSnack={setShowSnack} setSnackMessage={setSnackMessage} setSnackType={setSnackType}/>
        </div>
        <div style={classes.delDialogRight}>
            
            {/*bookDetails.timeline.map((element, index)=> <IndTimeLine key={`timelineitem-${index}`} element={element}/>)*/}
        </div>
      </div>
    )
  }

export default function BookingList({selectedBooking, bookings, open, setOpen, isMobile, setShowSnack, setSnackMessage, setSnackType}) {
    const [bookDetails, setBookDetails] = useState({});
    useEffect(()=>{
        if (open) {
            const book = bookings.find(book=>book._id === selectedBooking)
            setBookDetails(book)
        }
      }, [open])
    return (
        <DialogWindow
          title={`Booking Details ${getTicketId(bookDetails?._id)}`}
          Body={<Body bookDetails={bookDetails} isMobile={isMobile} setShowSnack={setShowSnack} setSnackMessage={setSnackMessage} setSnackType={setSnackType}/>}
          Actions={null}
          open={open}
          setOpen={setOpen}
          maxWidth={'md'}
        />
    )
}